module.exports = __webpack_public_path__ + "static/Tobiasz-49bffe3a01c53096845831cbfebfc06a.mp4";